export default "__VITE_ASSET__bCgMSdur__"